import { Typography, styled } from '@mui/material'
import { t } from '$i18n'

const Root = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 100%;
`

export function MessageListEmpty() {
  return (
    <Root>
      <div
        style={{
          height: '32px',
          backgroundColor: '#0000004D',
          boxSizing: 'border-box',
          padding: '5px 30px',
          borderRadius: '21px',
        }}
      >
        <Typography
          color="white"
          variant="paragraph3"
          sx={{ display: 'block', paddingTop: '1px' }}
        >
          {t('emptyState.noMessages')}
        </Typography>
      </div>
    </Root>
  )
}
